// Gated debug logging for the routing pipeline — which engine gets tried,
// how long each attempt takes, and why a given waypoint edit triggered a
// full reroute vs a cheap stale-leg-only reroute. Off by default in a
// production build so real users never see it; auto-on in `npm run dev`.
//
// To turn it on against a deployed build (staging/prod), run this once in
// the browser console and reload:
//   localStorage.setItem('motoroam_debug_routing', '1')
// and to turn it back off:
//   localStorage.removeItem('motoroam_debug_routing')

export const routingDebugEnabled = (() => {
  if (import.meta.env.DEV) return true;
  try { return localStorage.getItem('motoroam_debug_routing') === '1'; } catch { return false; }
})();

export function rlog(...args) {
  if (!routingDebugEnabled) return;
  console.log('%c[routing]', 'color:#ff7a1a;font-weight:700', ...args);
}

export function rwarn(...args) {
  if (!routingDebugEnabled) return;
  console.warn('%c[routing]', 'color:#ff7a1a;font-weight:700', ...args);
}

// performance.now() when enabled, else 0 (so callers can unconditionally do
// `const ms = rnow() - t0` without an extra enabled-check at every call site).
export function rnow() {
  return routingDebugEnabled ? performance.now() : 0;
}
